import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

export const FloatingCallButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href="tel:0650242913"
      aria-label="Nous appeler"
      className={`fixed z-50 bottom-6 right-6 md:bottom-8 md:right-8 group transition-opacity duration-300 ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      <div className="relative flex items-center bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-2xl shadow-blue-600/40 pl-4 pr-5 py-3 md:py-4 space-x-2 md:space-x-3">
        <span className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 bg-white/20 rounded-full">
          <Phone className="w-4 h-4 md:w-5 md:h-5" />
        </span>
        <span className="hidden sm:flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-wider text-blue-100">Appeler</span>
          <span className="text-sm md:text-base font-semibold">06 50 24 29 13</span>
        </span>
      </div>
    </a>
  );
};
